import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fetchOrderDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectGuestOrderOrderRef,
  makeSelectOrderDetails,
  makeSelectInProgressReplaceSim
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { ORDER_ACTION_TYPES } from "utils/constants";
import ReplaceWithEsim from "./ReplaceWithEsim";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import ReplaceWithEsimStatus from "./ReplaceWithEsimStatus";

const ReplaceWithEsimAction = props => {
  const {
    isFetchingOrderDetails,
    isSubmittingReplaceSim,
    orderDetails,
    match
  } = props;

  const { status: confirmationStatus } = get(match, "params", {});

  const enhancedProps = {
    ...props,
    confirmationStatus
  };

  if (isFetchingOrderDetails || isSubmittingReplaceSim || isEmpty(orderDetails))
    return <Spinner size={200} sx={styles.fullPage} />;

  const Component = confirmationStatus
    ? ReplaceWithEsimStatus
    : ReplaceWithEsim;

  return <Component {...enhancedProps} />;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  inProgressReplaceSim: makeSelectInProgressReplaceSim(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  isSubmittingReplaceSim: makeSelectIsFetchingData("submitReplaceSim")
});

export const mapDispatchToProps = dispatch => {
  return {
    fetchOrderDetails: orderRef => {
      const params = {
        type: ORDER_ACTION_TYPES.REPORT_LOST_SIM_CARD,
        order_ref: orderRef
      };

      dispatch(fetchOrderDetails(params));
    }
  };
};

ReplaceWithEsimAction.defaultProps = {
  fetchOrderDetails: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(ReplaceWithEsimAction);
